// Notification types themselves are never hardcoded — they come from CV.NotificationType via the
// API, and the UI shows nothing if that call returns nothing. Only the channel restrictions below
// are held here, keyed by the SystemName of a row in that table.
//
// Interim: these keys are maintained by hand, so a rename or removal in CV.NotificationType
// silently disables the rule (every lookup is optional). The intent is to move them onto the
// table as columns so the database is the single source of truth.

// Channel restrictions per notification type — hardcoded by design.
// "SMS is not available" per the spec: Agent-Assisted Booking Updates, Outstanding Dangerous Goods
// Manifest, Account Booking Activity, and the Monday/Friday reminder. SMS is only offered on
// disruption notifications and the two unconfirmed booking reminders.
export const DISABLED_CHANNELS: Partial<Record<string, readonly string[]>> = {
	BookingUpdateCancellation: ["sms"],
	OutstandingDGReminder: ["sms"],
	NewBookingOnAccount: ["sms"],
	UnconfirmedBookingReminder: ["sms"]
};

// Channels forced ON and locked per notification type.
// "In-portal notifications are mandatory" for disruption notifications.
export const FORCED_CHANNELS: Partial<Record<string, readonly string[]>> = {
	ServiceDisruptions: ["portal"]
};

// Notification types that require at least one of the listed channels to be selected.
// Nothing per-type today: the spec has phone and email as optional extras ("can also select").
export const REQUIRED_ONE_OF_CHANNELS: Partial<Record<string, readonly string[]>> = {};

// Cross-type rules: at least one notification type in the group must have the listed channel
// selected. In-portal must be on for the first or the final unconfirmed booking reminder (both is
// fine), so neither box can simply be locked on — it is validated instead.
export const REQUIRED_ONE_OF_ROWS: readonly {
	systemNames: readonly string[];
	channel: "portal" | "email" | "sms";
	message: string;
}[] = [
	{
		systemNames: ["FirstMessageUnconfirmed", "SecondMessageUnconfirmed"],
		channel: "portal",
		message:
			"In-portal must be selected for at least one of the first or final unconfirmed booking reminders"
	}
];
